export const MERCEDES_XENTRY_LINK = 'MERCEDES_XENTRY_LINK';
